export default __webpack_public_path__ + "static/media/Facebook.d4b4bd30.svg";